import Home from "../../assets/home.svg";
import Skills from "../../assets/skills.svg";
import Projects from "../../assets/projects.svg";
import Contact from "../../assets/contact.svg";
export const Navlist = [
  {
    connection: "home",
    name: Home,
    path: "./home",
    id: 1,
    cName: "home-item",
  },
  {
    connection: "skills",
    name: Skills,
    path: "./skills",
    id: 2,
    cName: "skills-item",
  },
  {
    connection: "portfolio",
    name: Projects,
    path: "./project",
    id: 3,
    cName: "project-item",
  },
  {
    connection: "achievements",
    name: Contact,
    path: "./achievements",
    id: 4,
    cName: "contact-item",
  },
];
